module.exports = __webpack_public_path__ + "img/img5.ab99d14c.png";